// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"6450c58e","212":"044856f1","382":"ea0993e8","453":"b03e3c98","622":"2f42c608","778":"3da7db33","806":"584111e3","844":"1f8c6ac5"}[chunkId] + ".chunk.js";
};